import {fontText} from '../assets/fontConstant'


export const colors = {
    primary: "#47c5a6",
    secondry: "#fff",
    FontColor : "#fff",
    Green:"#00cc00",
    catColor:"#000000",
    PriceColor:"#000000",
}

export const btn = {
    backgroundColor:colors.primary,
    color:colors.FontColor,
    fontFamily:fontText.ButtonNHeaderText
    
}



